import { EChartIndicator } from '@aqx-core/common/api/user-account-setting';

import { EInputType } from '../../equity-chart';

export enum EIndicatorConfigType {
  INPUT = 'INPUT',
  STYLE = 'STYLE'
}

export enum EIndicatorSettingsTabs {
  INPUT = 'INPUT',
  STYLE = 'STYLE',
  DESCRIPTION = 'DESCRIPTION'
}

export enum EIndicatorConfigFieldType {
  INPUT = 'inputFields',
  STYLE = 'styleFields'
}

export interface IMovingAverageFormValue {
  firstPeriod: number;
  secondPeriod: number;
  thirdPeriod: number;
  firstColor: string;
  secondColor: string;
  thirdColor: string;
}

export interface IRsiFormValue {
  period: number;
  color: string;
}

export interface IEmaFormValue {
  period: number;
  color: string;
}

export interface IWmaFormValue {
  period: number;
  color: string;
}

export interface IAtrFormValue {
  period: number;
  color: string;
}

export interface ICciFormValue {
  period: number;
  color: string;
}

export interface ISdFormValue {
  period: number;
  color: string;
}

export interface ISarFormValue {
  max: number;
  step: number;
  color: string;
}

export interface IBollingerBandsFormValue {
  stdDev: number;
  period: number;
  upperColor: string;
  middleColor: string;
  lowerColor: string;
}

export interface IMacdFormValue {
  fastPeriod: number;
  slowPeriod: number;
  signalPeriod: number;
  lineColor: string;
  signalLineColor: string;
  //* Ignored in the current implementation by UI design
  barPositiveColor?: string;
  barNegativeColor?: string;
}

export interface IStochasticOscillatorFormValue {
  period: number;
  signalPeriod: number;
  periodColor: string;
  signalPeriodColor: string;
}

export interface IIndicatorFormValuesMap {
  [EChartIndicator.TI_MA]?: IMovingAverageFormValue;
  [EChartIndicator.TI_SAR]?: ISarFormValue;
  [EChartIndicator.TI_BOLL]?: IBollingerBandsFormValue;
  [EChartIndicator.TI_MACD]?: IMacdFormValue;
  [EChartIndicator.TI_CCI]?: ICciFormValue;
  [EChartIndicator.TI_RSI]?: IRsiFormValue;
  [EChartIndicator.TI_SD]?: ISdFormValue;
  [EChartIndicator.TI_SO]?: IStochasticOscillatorFormValue;
  [EChartIndicator.TI_ATR]?: IAtrFormValue;
  [EChartIndicator.TI_EMA]?: IEmaFormValue;
  [EChartIndicator.TI_WMA]?: IWmaFormValue;
}

interface IIndicatorConfigKeyMap {
  [EChartIndicator.TI_MA]: keyof IMovingAverageFormValue;
  [EChartIndicator.TI_BOLL]: keyof IBollingerBandsFormValue;
  [EChartIndicator.TI_EMA]: keyof IEmaFormValue;
  [EChartIndicator.TI_SAR]: keyof ISarFormValue;
  [EChartIndicator.TI_WMA]: keyof IWmaFormValue;
  [EChartIndicator.TI_MACD]: keyof IMacdFormValue;
  [EChartIndicator.TI_ATR]: keyof IAtrFormValue;
  [EChartIndicator.TI_CCI]: keyof ICciFormValue;
  [EChartIndicator.TI_RSI]: keyof IRsiFormValue;
  [EChartIndicator.TI_SD]: keyof ISdFormValue;
  [EChartIndicator.TI_SO]: keyof IStochasticOscillatorFormValue;
}

export interface IIndicatorConfigField<T extends keyof IIndicatorConfigKeyMap = keyof IIndicatorConfigKeyMap> {
  key: IIndicatorConfigKeyMap[T];
  value: string;
  label: string;
  defaultValue: string;
  type: EInputType;
}
